import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NumericHandlingService {
    constructor() {}

    /**
     * Converts bytes to megabytes
     * @param bytes - number in bytes
     */
    convertBytesToMegaBytes(bytes: number) {
        return bytes / (1024 * 1024);
    }
}
